module.exports = __webpack_public_path__ + "img/widget-theme-selection.5d3f40d6.jpg";